<template>
  <div>
    <ImageCounter
      :value="value"
      class="image-counter align-items-center"
      :option="data.option"
      :theme="data.option.theme"
      :skip-q-message="data.skipQuestionMessage"
      @input="updateAnswer"
      @autoprogress="skipQuestion"
    >
      <PopupClickArea class="app-popup-click-area" @openPopup="popup(true)">
        See the app features
      </PopupClickArea>
    </ImageCounter>
    <transition name="slide-up">
      <PopupBox
        v-if="showPopup"
        class="popup-box"
        :title="'The cloud phone web app features'"
        :sub-title="'Our experts will help you choose the calling features your  business actually needs today and for the future.'"
        @closePopup="popup(false)"
      >
        <div class="popup-box__container">
          <img
            class="popup-box__image-mobile"
            src="@/assets/images/mobile-apps.png"
            alt="mobile apps"
          >
          <div>
            <ToggleBox
              v-for="(feature, i) in appFeatures"
              :key="i"
              :item="feature"
            />
          </div>
          <img
            class="popup-box__image-desktop"
            src="@/assets/images/laptop-apps.png"
            alt="laptop voip apps"
          >
        </div>
      </PopupBox>
    </transition>
  </div>
</template>

<script>
import PopupClickArea from '@/components/ui/PopupClickArea'
import ImageCounter from '@/components/question/inputs/ImageCounter'
import PopupBox from '@/components/ui/PopupBox'
import ToggleBox from '@/components/ui/ToggleBox'
import { appFeatures } from '@/assets/data/products/appFeatures'
import Utag from '@/mixins/Utag'

export default {
  name: 'DesktopMobileApp',
  components: {
    ImageCounter,
    PopupClickArea,
    PopupBox,
    ToggleBox
  },
  mixins: [Utag],
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      answer: {},
      showPopup: false,
      appFeatures
    }
  },
  mounted () {
    if (this.value && this.value.result) this.answer = this.value.result
  },
  methods: {
    skipQuestion () {
      this.updateTracking(this.data.trackingSkipQ)
      this.$emit('input', { result: 0 })
      this.$emit('autoprogress', true)
      this.$emit('skippedQuestion', true, this.data.questionId)
    },
    updateAnswer (input) {
      this.$emit('input', { result: input.result })
    },
    popup (popupBoolean) {
      this.showPopup = popupBoolean
      if (popupBoolean) {
        this.updateTracking(this.data.tracking)
      }
    },
    updateTracking (trackingData) {
      if (trackingData) {
        this.generalTracking(trackingData)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.image-counter {
  padding-top: 0;
  margin-top: -10px;
}

.app-popup-click-area {
  @media (max-width: $screen-md) {
    justify-content: center;
    top: 0;
  }
}
.popup-box {
  &__container {
    @media (min-width: 995px) {
      display: flex;
      align-items: flex-start;
    }
  }

  &__image {
    &-mobile {
      width: 120px;
      @media (min-width: $screen-md) {
        display: none;
      }
    }

    &-desktop {
      width: 450px;
      max-width: 100%;
      margin-top: 76px;
      position: fixed;
      right: 0;
      display: none;

      @media (min-width: 995px) {
        display: block;
      }

      @media (min-width: 1080px) {
        width: 570px;
      }

      @media (min-width: 1300px) {
        right: 80px;
      }

      @media (min-width: 1400px) {
        right: 140px;
      }
    }
  }
}
</style>
